import { Injectable } from "@angular/core";
import { ToastEvents } from "../elements/toast/toast.events";

@Injectable()

export class ErrorHandlerService {
  public handleError(err:any, defaultErrorTitle?: string, defaultErrorMessage?: string):void {
    console.log(err);
    return;//temporary measure while the toast is broken
    if (err.error && err.error.userFriendlyErrors && err.error.userFriendlyErrors.length){
      err.error.userFriendlyErrors.forEach((error: UserFriendlyError) => {
        ToastEvents.dispatchError(error.title, error.message, error.errorCode)
      });
    }
    else {
      ToastEvents.dispatchError(defaultErrorTitle || 'Internal Server Error', defaultErrorMessage || 'An unknown error has occurred. Please contact support.')
    }
  }
}

export interface UserFriendlyError {
  errorCode: string;
  message: string;
  title: string;
}
